import React from 'react';
import AppImage from './AppImage';

export default function BrandLogo({
  variant = "careerlift",
  className = "h-8 w-auto",
  alt
}) {
  const isCareerLift = variant === "careerlift";
  const altText = alt || (isCareerLift ? "CareerLift logo" : "SkillBinder logo");
  
  return (
    <picture>
      {isCareerLift && (
        <source 
          media="(max-width: 640px)" 
          srcSet="/assets/images/CareerLift_Logo_Vertical-1757446895898.png" 
        />
      )}
      <AppImage
        src={
          isCareerLift
            ? "/assets/images/CareerLift_Logo-1757425914868.png"
            : "/assets/images/SkillBinder_Logo_PNG_format-1757444619599.png"
        }
        alt={altText}
        className={className}
        loading="eager"
        decoding="async"
      />
    </picture>
  );
}